export type ActivityType = "Call" | "Note" | "Email" | "Stage Change" | "Lead Created";

export interface Activity {
  id: number;
  leadId: number;
  type: ActivityType;
  description: string;
  agent: string;
  timestamp: string;
  systemEvent: boolean;
}

export const activityIconColors: Record<ActivityType, string> = {
  Call: "bg-blue-100 text-blue-600",
  Note: "bg-amber-100 text-amber-600",
  Email: "bg-purple-100 text-purple-600",
  "Stage Change": "bg-gray-100 text-gray-500",
  "Lead Created": "bg-green-100 text-green-500",
};

export const activityIcons: Record<ActivityType, string> = {
  Call: "ri-phone-line",
  Note: "ri-sticky-note-line",
  Email: "ri-mail-line",
  "Stage Change": "ri-arrow-left-right-line",
  "Lead Created": "ri-user-add-line",
};

export function getActivitiesForLead(leadId: number): Activity[] {
  const allActivities: Activity[] = [
    {
      id: 1, leadId: 1, type: "Call",
      description: "Called and discussed pricing. Client interested in annual plan with premium features. Asked for a formal proposal within 3 days.",
      agent: "Rajesh Kumar", timestamp: "2 hours ago", systemEvent: false,
    },
    {
      id: 2, leadId: 1, type: "Note",
      description: "Sent product brochure via WhatsApp along with pricing tiers. Follow up call scheduled for tomorrow morning.",
      agent: "Rajesh Kumar", timestamp: "1 day ago", systemEvent: false,
    },
    {
      id: 3, leadId: 1, type: "Email",
      description: "Initial outreach email sent with company introduction and product overview. No response received yet.",
      agent: "Priya Sharma", timestamp: "3 days ago", systemEvent: false,
    },
    {
      id: 4, leadId: 1, type: "Stage Change",
      description: "Stage changed from Qualified to Negotiation",
      agent: "System", timestamp: "5 days ago", systemEvent: true,
    },
    {
      id: 5, leadId: 1, type: "Lead Created",
      description: "Lead created from IndiaMart inquiry — TechVentures Inc looking for CRM solution",
      agent: "System", timestamp: "7 days ago", systemEvent: true,
    },
    {
      id: 6, leadId: 2, type: "Email",
      description: "Sent proposal document with detailed pricing breakdown and implementation timeline.",
      agent: "Priya Sharma", timestamp: "3 hours ago", systemEvent: false,
    },
    {
      id: 7, leadId: 2, type: "Call",
      description: "Discussed requirements over phone. Client needs retail POS integration with existing systems.",
      agent: "Priya Sharma", timestamp: "1 day ago", systemEvent: false,
    },
    {
      id: 8, leadId: 2, type: "Stage Change",
      description: "Stage changed from Qualified to Proposal",
      agent: "System", timestamp: "2 days ago", systemEvent: true,
    },
    {
      id: 9, leadId: 2, type: "Lead Created",
      description: "Lead created from JustDial inquiry — GreenLeaf Organics",
      agent: "System", timestamp: "5 days ago", systemEvent: true,
    },
    {
      id: 10, leadId: 3, type: "Call",
      description: "Discovery call completed. Skyline is planning a major expansion and needs CRM for their sales team of 50+.",
      agent: "Rajesh Kumar", timestamp: "6 hours ago", systemEvent: false,
    },
    {
      id: 11, leadId: 3, type: "Email",
      description: "Sent case studies from similar construction clients to build credibility.",
      agent: "Rajesh Kumar", timestamp: "1 day ago", systemEvent: false,
    },
    {
      id: 12, leadId: 3, type: "Lead Created",
      description: "Lead created from website contact form — Skyline Architects",
      agent: "System", timestamp: "3 days ago", systemEvent: true,
    },
    {
      id: 13, leadId: 5, type: "Note",
      description: "Client messaged on WhatsApp asking about pricing for small business plan.",
      agent: "Sneha Rao", timestamp: "30 mins ago", systemEvent: false,
    },
    {
      id: 14, leadId: 5, type: "Lead Created",
      description: "Lead created from WhatsApp inquiry — NovaTech Labs",
      agent: "System", timestamp: "1 day ago", systemEvent: true,
    },
    {
      id: 15, leadId: 8, type: "Call",
      description: "Excellent call with Sunita. PropMax is looking for CRM across 3 offices. Deal potential is significant.",
      agent: "Rajesh Kumar", timestamp: "4 hours ago", systemEvent: false,
    },
    {
      id: 16, leadId: 8, type: "Email",
      description: "Shared demo video and feature comparison with competitors.",
      agent: "Rajesh Kumar", timestamp: "1 day ago", systemEvent: false,
    },
    {
      id: 17, leadId: 8, type: "Stage Change",
      description: "Stage changed from Contacted to Qualified",
      agent: "System", timestamp: "2 days ago", systemEvent: true,
    },
    {
      id: 18, leadId: 8, type: "Lead Created",
      description: "Lead created from TradeIndia inquiry — PropMax Realty",
      agent: "System", timestamp: "4 days ago", systemEvent: true,
    },
    {
      id: 19, leadId: 4, type: "Call",
      description: "Final confirmation call. Kavita confirmed they are ready to sign. Contract sent for e-signature.",
      agent: "Amit Patel", timestamp: "2 days ago", systemEvent: false,
    },
    {
      id: 20, leadId: 4, type: "Stage Change",
      description: "Stage changed from Negotiation to Closed Won — Deal closed at ₹8,900",
      agent: "System", timestamp: "2 days ago", systemEvent: true,
    },
    {
      id: 21, leadId: 4, type: "Lead Created",
      description: "Lead created from Social Media ad campaign — BluePeak Media",
      agent: "System", timestamp: "10 days ago", systemEvent: true,
    },
    {
      id: 22, leadId: 9, type: "Note",
      description: "FastBuild requested site visit to demonstrate product to their entire management team.",
      agent: "Priya Sharma", timestamp: "1 hour ago", systemEvent: false,
    },
    {
      id: 23, leadId: 9, type: "Call",
      description: "Introductory call went well. Manoj is the decision maker for this purchase.",
      agent: "Priya Sharma", timestamp: "3 days ago", systemEvent: false,
    },
    {
      id: 24, leadId: 9, type: "Lead Created",
      description: "Lead created from website demo request — FastBuild Corp",
      agent: "System", timestamp: "5 days ago", systemEvent: true,
    },
  ];

  return allActivities.filter((a) => a.leadId === leadId);
}